import script from "./SignInForgotPasswordPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignInForgotPasswordPage.vue?vue&type=script&setup=true&lang=ts"

import "./SignInForgotPasswordPage.vue?vue&type=style&index=0&id=bdcd130c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdcd130c"]])

export default __exports__